<div class="title-actions" #main [ngStyle]="{'overflow-x': !panelData ? 'hidden': ''}">
    <div class="title">
        <span>{{panelData ? panelData.title : "Actions"}}</span>
        <mat-icon *ngIf="creating && panelData" [matMenuTriggerFor]="titleMenu"
            [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <div class="alignRow banner" style="display: flex;">
        <mat-icon style="margin-right: 0.2em;">pending_actions</mat-icon>
        <span style="font-size: large; font-weight: bolder;">Action List</span>
        <span class="toolbar-spacer"></span>
        <div class="alignRow">
            <span>My Actions Only</span>
            <mat-checkbox color="primary" [checked]="myActionsOnly"
                (change)="toggleCheckbox($event, false)"></mat-checkbox>
        </div>
        <div class="alignRow">
            <span>Overdue Only</span>
            <mat-checkbox color="primary" [checked]="overdueOnly"
                (change)="toggleCheckbox($event, true)"></mat-checkbox>
        </div>
    </div>
    <div class="watchlist-container">
        <div class="action-list-grid" style="font-size: larger;">
            <span>Action</span>
            <span>Asset</span>
            <span>Assigned To</span>
            <span>Target Completion Date</span>
            <span>Details</span>
        </div>
        <ejs-listbox [dataSource]='filteredActions' [fields]="fields" cssClass='e-list-template'>
            <ng-template #itemTemplate let-data>
                <div title="Click to go to Action" *ngIf="Actions" class="action-list-grid ejs-listbox-item"
                    [ngStyle]="{'background-color': checkIfOverdue(data) ? 'salmon' : ''}"
                    routerLink="/{{accountID}}/organisation/{{organisationUID}}/actions/{{data.ActionID}}">
                    <span style="font-weight: bolder;">{{ getActionTypeFromValue(data.ActionType) }}</span>
                    <span>{{ data.AssetName }}</span>
                    <span>{{ data.AssignedToUserSub }}</span>
                    <span>{{ convertEpochNoTime(data.TargetCompletionTimestamp) }}</span>
                    <span>{{ data.Details }}</span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
</div>